import type { HeadLine } from '../../interfaces'

export const headerCheck: HeadLine[] = [
  {
    title: 'Group#',
    dataIndex: 'groupNumber',
    key: 'groupNumber'
  },
  {
    title: 'Group Name',
    dataIndex: 'groupName',
    key: 'groupName'
  },
  {
    title: 'Location',
    dataIndex: ['location', 'short_name'],
    key: 'location'
  },
  {
    title: 'Report',
    dataIndex: 'reportType',
    key: 'reportType'
  },
  {
    title: 'Date',
    dataIndex: 'fileDate',
    key: 'fileDate'
  },
  {
    title: 'Download',
    dataIndex: 'download',
    key: 'download'
  }
]
